import { apiClient } from './client';

export interface ApiKey {
  id: string;
  name: string;
  keyPrefix: string;
  scopes: string[];
  lastUsedAt: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  createdAt: string;
}

export const apiKeysApi = {
  list: async (): Promise<ApiKey[]> => {
    const res = await apiClient.get('/api-keys');
    return res.data.data.keys as ApiKey[];
  },

  // Returns the created key metadata AND the plaintext secret (shown once).
  create: async (data: { name: string; scopes?: string[]; expiresAt?: string }): Promise<{ apiKey: ApiKey; key: string }> => {
    const res = await apiClient.post('/api-keys', data);
    return res.data.data as { apiKey: ApiKey; key: string };
  },

  /** Change what a live key may do, without rotating its secret. */
  updateScopes: async (id: string, scopes: string[]): Promise<ApiKey> => {
    const res = await apiClient.patch(`/api-keys/${id}`, { scopes });
    return res.data.data.apiKey as ApiKey;
  },

  revoke: async (id: string): Promise<void> => {
    await apiClient.post(`/api-keys/${id}/revoke`, {});
  },
};
